// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.EditProfessionalInfo_professional-detail__main__Ri56v {
  padding-right: 0px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 990px) {
  .EditProfessionalInfo_professional-detail__main__Ri56v {
    padding-right: 0;
  }
}

.EditProfessionalInfo_action-bar__Jg45A {
  width: 100%;
  text-align: left;
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  order: 1;
}
@media (max-width: 820px) {
  .EditProfessionalInfo_action-bar__Jg45A {
    order: 2;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    justify-content: center;
  }
}

.EditProfessionalInfo_media-section__XFeRc {
  order: 2;
}
@media (max-width: 820px) {
  .EditProfessionalInfo_media-section__XFeRc {
    order: 1;
  }
}

.EditProfessionalInfo_content-section__uZ9rV {
  order: 3;
}

.EditProfessionalInfo_edit-profile-btn__yOmyR {
  appearance: none;
  background: #82B194;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 14px;
  font-weight: 800;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s ease;
}
.EditProfessionalInfo_edit-profile-btn__yOmyR:hover {
  background: #739F84;
}
@media (max-width: 820px) {
  .EditProfessionalInfo_edit-profile-btn__yOmyR {
    width: 100%;
    padding: 14px 20px;
    font-size: 14px;
  }
}

.EditProfessionalInfo_acceptance-card__jE2Jm {
  padding: 24px;
  border: 1px solid rgba(36, 46, 123, 0.24);
  border-radius: 20px;
  background: rgba(36, 46, 123, 0.05);
  margin-bottom: 24px;
}

.EditProfessionalInfo_section-heading__zTzau {
  margin: 0 0 16px 0;
  color: var(--text-main, #13231D);
  font-size: 17px;
  font-weight: 700;
}

.EditProfessionalInfo_acceptance-copy__q0zkG {
  color: var(--text-muted, #4F5F59);
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.EditProfessionalInfo_acceptance-copy__q0zkG p {
  margin-top: 0;
  margin-bottom: 12px;
}

.EditProfessionalInfo_acceptance-copy__q0zkG p:last-child {
  margin-bottom: 0;
}

.EditProfessionalInfo_acceptance-check__Xe8Ep {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  font-size: 13px;
  color: var(--text-main, #13231D);
  font-weight: 500;
  line-height: 1.5;
}

.EditProfessionalInfo_acceptance-check__Xe8Ep input[type=checkbox] {
  margin-top: 3px;
}

.EditProfessionalInfo_profile-actions-sticky__GQuFt {
  position: sticky;
  top: 94px;
  z-index: 42;
  width: 100%;
  padding-top: 0;
  background: transparent;
}
@media (max-width: 1024px) {
  .EditProfessionalInfo_profile-actions-sticky__GQuFt {
    position: sticky;
    top: 60px;
    z-index: 50;
    padding: 6px 0 8px;
    background: #EFF0EC;
    margin-bottom: 8px;
  }
}

.EditProfessionalInfo_profile-actions__da9Rh {
  margin-bottom: 12px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 22px;
  background: #F7F5F1;
  box-shadow: 0 10px 26px rgba(18, 34, 29, 0.06);
}
@media (max-width: 1024px) {
  .EditProfessionalInfo_profile-actions__da9Rh {
    margin-bottom: 0;
    border-radius: 18px;
    padding: 8px 10px;
  }
}

.EditProfessionalInfo_btn-edit__jiQgl {
  outline: none;
  border: 1px solid #82B194;
  background: #82B194;
  color: #fff;
  min-height: 40px;
  margin: 0 !important;
  padding: 0 18px;
  border-radius: 14px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.EditProfessionalInfo_btn-edit__jiQgl:hover:not(:disabled) {
  background: rgb(114.2980295567, 167.2019704433, 134.5591133005);
}
.EditProfessionalInfo_btn-edit__jiQgl:disabled, .EditProfessionalInfo_btn-edit__jiQgl[aria-disabled=true] {
  opacity: 0.48;
  cursor: not-allowed;
  box-shadow: none;
}
.EditProfessionalInfo_btn-edit__jiQgl:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);
}

.EditProfessionalInfo_btn-preview__bHpJM {
  outline: none;
  border: 1px solid rgba(130, 177, 148, 0.58);
  background: transparent;
  color: #32453B;
  min-height: 40px;
  margin: 0 !important;
  padding: 0 18px;
  border-radius: 14px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.EditProfessionalInfo_btn-preview__bHpJM:hover {
  background: rgba(130, 177, 148, 0.05);
}
.EditProfessionalInfo_btn-preview__bHpJM:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/EditProfileProfessional/EditProfessionalInfo/EditProfessionalInfo.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;AAiBJ;AAfI;EALJ;IAMQ,gBAAA;EAkBN;AACF;;AAfA;EACI,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;AAkBJ;AAhBI;EATJ;IAUQ,QAAA;IACA,kBAAA;IACA,mBAAA;IACA,uBAAA;EAmBN;AACF;;AAhBA;EACI,QAAA;AAmBJ;AAjBI;EAHJ;IAIQ,QAAA;EAoBN;AACF;;AAjBA;EACI,QAAA;AAoBJ;;AAjBA;EACI,gBAAA;EACA,mBDhCmB;ECiCnB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAoBJ;AAlBI;EACI,mBD1Ce;AC8DvB;AAjBI;EAhBJ;IAiBQ,WAAA;IACA,kBAAA;IACA,eAAA;EAoBN;AACF;;AAjBA;EACI,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,mCAAA;EACA,mBAAA;AAoBJ;;AAjBA;EACI,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAoBJ;;AAjBA;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAoBJ;;AAjBA;EACI,aAAA;EACA,mBAAA;AAoBJ;;AAjBA;EACI,gBAAA;AAoBJ;;AAjBA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AAoBJ;;AAjBA;EACI,eAAA;AAoBJ;;AAjBA;EACI,gBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;AAoBJ;AAlBI;EARJ;IASQ,gBAAA;IACA,SAAA;IACA,WAAA;IACA,kBAAA;IACA,mBDzGe;IC0Gf,kBAAA;EAqBN;AACF;;AAlBA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AAqBJ;AAnBI;EAbJ;IAcQ,gBAAA;IACA,mBAAA;IACA,iBAAA;EAsBN;AACF;;AAnBA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAsBJ;AApBI;EACI,+DAAA;AAsBR;AAnBI;EAEI,aAAA;EACA,mBAAA;EACA,gBAAA;AAoBR;AAjBI;EACI,aAAA;EACA,8CAAA;AAmBR;;AAfA;EACI,aAAA;EACA,2CAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAkBJ;AAhBI;EACI,qCAAA;AAkBR;AAfI;EACI,aAAA;EACA,8CAAA;AAiBR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n.professional-detail__main {\n    padding-right: 0px;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 990px) {\n        padding-right: 0;\n    }\n}\n\n.action-bar {\n    width: 100%;\n    text-align: left;\n    margin-bottom: 0.75rem;\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    order: 1;\n\n    @media (max-width: 820px) {\n        order: 2;\n        margin-top: 0.5rem;\n        margin-bottom: 1rem;\n        justify-content: center;\n    }\n}\n\n.media-section {\n    order: 2;\n\n    @media (max-width: 820px) {\n        order: 1;\n    }\n}\n\n.content-section {\n    order: 3;\n}\n\n.edit-profile-btn {\n    appearance: none;\n    background: $color-primary;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 14px;\n    font-weight: 800;\n    cursor: pointer;\n    font-size: 13px;\n    transition: background 0.2s ease;\n\n    &:hover {\n        background: $color-primary-hover;\n    }\n\n    @media (max-width: 820px) {\n        width: 100%;\n        padding: 14px 20px;\n        font-size: 14px;\n    }\n}\n\n.acceptance-card {\n    padding: 24px;\n    border: 1px solid rgba(36, 46, 123, .24);\n    border-radius: 20px;\n    background: rgba(36, 46, 123, .05);\n    margin-bottom: 24px;\n}\n\n.section-heading {\n    margin: 0 0 16px 0;\n    color: var(--text-main, #13231D);\n    font-size: 17px;\n    font-weight: 700;\n}\n\n.acceptance-copy {\n    color: var(--text-muted, #4F5F59);\n    font-size: 13px;\n    line-height: 1.6;\n    margin-bottom: 20px;\n}\n\n.acceptance-copy p {\n    margin-top: 0;\n    margin-bottom: 12px;\n}\n\n.acceptance-copy p:last-child {\n    margin-bottom: 0;\n}\n\n.acceptance-check {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--text-main, #13231D);\n    font-weight: 500;\n    line-height: 1.5;\n}\n\n.acceptance-check input[type=\"checkbox\"] {\n    margin-top: 3px;\n}\n\n.profile-actions-sticky {\n    position: sticky;\n    top: 94px;\n    z-index: 42;\n    width: 100%;\n    padding-top: 0;\n    background: transparent;\n\n    @media (max-width: 1024px) {\n        position: sticky;\n        top: 60px;\n        z-index: 50;\n        padding: 6px 0 8px;\n        background: $color-bg;\n        margin-bottom: 8px;\n    }\n}\n\n.profile-actions {\n    margin-bottom: 12px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid rgba(19, 35, 29, 0.08);\n    border-radius: 22px;\n    background: #F7F5F1;\n    box-shadow: 0 10px 26px rgba(18, 34, 29, 0.06);\n\n    @media (max-width: 1024px) {\n        margin-bottom: 0;\n        border-radius: 18px;\n        padding: 8px 10px;\n    }\n}\n\n.btn-edit {\n    outline: none;\n    border: 1px solid #82B194;\n    background: #82B194;\n    color: #fff;\n    min-height: 40px;\n    margin: 0 !important;\n    padding: 0 18px;\n    border-radius: 14px;\n    font-family: inherit;\n    font-size: 12px;\n    font-weight: 800;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover:not(:disabled) {\n        background: darken(#82B194, 5%);\n    }\n\n    &:disabled,\n    &[aria-disabled=\"true\"] {\n        opacity: 0.48;\n        cursor: not-allowed;\n        box-shadow: none;\n    }\n\n    &:focus-visible {\n        outline: none;\n        box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);\n    }\n}\n\n.btn-preview {\n    outline: none;\n    border: 1px solid rgba(130, 177, 148, .58);\n    background: transparent;\n    color: #32453B;\n    min-height: 40px;\n    margin: 0 !important;\n    padding: 0 18px;\n    border-radius: 14px;\n    font-family: inherit;\n    font-size: 12px;\n    font-weight: 800;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background: rgba(130, 177, 148, 0.05);\n    }\n\n    &:focus-visible {\n        outline: none;\n        box-shadow: 0 0 0 2px rgba(130, 177, 148, 0.5);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"professional-detail__main": `EditProfessionalInfo_professional-detail__main__Ri56v`,
	"action-bar": `EditProfessionalInfo_action-bar__Jg45A`,
	"media-section": `EditProfessionalInfo_media-section__XFeRc`,
	"content-section": `EditProfessionalInfo_content-section__uZ9rV`,
	"edit-profile-btn": `EditProfessionalInfo_edit-profile-btn__yOmyR`,
	"acceptance-card": `EditProfessionalInfo_acceptance-card__jE2Jm`,
	"section-heading": `EditProfessionalInfo_section-heading__zTzau`,
	"acceptance-copy": `EditProfessionalInfo_acceptance-copy__q0zkG`,
	"acceptance-check": `EditProfessionalInfo_acceptance-check__Xe8Ep`,
	"profile-actions-sticky": `EditProfessionalInfo_profile-actions-sticky__GQuFt`,
	"profile-actions": `EditProfessionalInfo_profile-actions__da9Rh`,
	"btn-edit": `EditProfessionalInfo_btn-edit__jiQgl`,
	"btn-preview": `EditProfessionalInfo_btn-preview__bHpJM`
};
export default ___CSS_LOADER_EXPORT___;
